// Giới hạn số TỪ cho mọi ô nhập chat (Kinh Dịch, Tử Vi, Bát Tự, Bói Đê,
// CSKH, Bói Live gõ text). Đổi qua env VITE_CHAT_WORD_LIMIT; mặc định 200 từ.
const envLimit = Number(import.meta.env.VITE_CHAT_WORD_LIMIT);

export const CHAT_WORD_LIMIT =
  Number.isFinite(envLimit) && envLimit > 0 ? Math.floor(envLimit) : 200;

export function countWords(text: string): number {
  const trimmed = text.trim();
  return trimmed ? trimmed.split(/\s+/).length : 0;
}

/** Cắt chuỗi còn tối đa `limit` từ (giữ nguyên khoảng trắng giữa các từ). */
export function clampWords(text: string, limit: number = CHAT_WORD_LIMIT): string {
  if (limit <= 0) return text;
  const re = /\S+/g;
  let count = 0;
  let match: RegExpExecArray | null;
  while ((match = re.exec(text))) {
    count += 1;
    if (count === limit) return text.slice(0, match.index + match[0].length);
  }
  return text;
}
